import React from 'react'
import GridExample from './tabledata'
import { Container } from 'reactstrap'
function TableOne() {
    console.log('Rendering TableOne')
    return (



        <GridExample />

    )
}

export default TableOne